import * as Yup from 'yup';
import { ReceivingSessionSchema } from './receiving';

// Yup schemas for the payload (NOT the wire message) of each inbound
// receiving-related WS action. The WS layer owns the `action` field — these
// schemas intentionally contain only domain fields.

export const receivingSessionUpdatedPayloadSchema = Yup.object({
  session: ReceivingSessionSchema.required(),
  // Transient one-shot hint, set by the backend only when a Resume probe was
  // refused (companion replied rcv_resume_result{ready:false}). Never persisted
  // on the session; absent on every routine broadcast.
  probe_refused: Yup.boolean().default(false),
  // Abandon-side analogue of probe_refused: set only when the companion refused
  // the Abandon clear with rcv_clear_result{busy:true} (LPOS holds the file —
  // session kept alive unchanged). Never persisted; absent on routine broadcasts.
  abandon_busy: Yup.boolean().default(false),
});

export type ReceivingSessionUpdatedPayload = Yup.InferType<
  typeof receivingSessionUpdatedPayloadSchema
>;

export const companionStatusChangedPayloadSchema = Yup.object({
  machine_id: Yup.string().required(),
  connected: Yup.boolean().required(),
});

export type CompanionStatusChangedPayload = Yup.InferType<
  typeof companionStatusChangedPayloadSchema
>;

export const sessionLeaseReleasedPayloadSchema = Yup.object({
  session_id: Yup.string().required(),
});

export type SessionLeaseReleasedPayload = Yup.InferType<typeof sessionLeaseReleasedPayloadSchema>;

export const storeUpdatedPayloadSchema = Yup.object({
  store_id: Yup.string().required(),
  // RFC3339 string (NOT Yup.date()): the WS provider validates with
  // { strict: true }, under which a date schema would reject the string and
  // skip the handler. Optional/nullable so an older backend that omits it still
  // validates.
  last_uploaded_at: Yup.string().nullable().optional(),
});

export type StoreUpdatedPayload = Yup.InferType<typeof storeUpdatedPayloadSchema>;
